import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const MotherhoodStoryPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  // Additional effect to ensure header links get random colors
  useEffect(() => {
    const headerLinks = document.querySelectorAll('header a');
    headerLinks.forEach(link => {
      // Always apply a random color, regardless of data-color-applied attribute
      link.style.color = getRandomColor();
      link.dataset.colorApplied = 'true';
    });
  }, []);
  // Keep only the original image
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/jv6s9FZZbpYkJVGJH8Bfca/Madeleine-Morlet_1-1.jpg'];
  // Create varied spacing and sizing for editorial layout
  const getSpacing = index => {
    const spacings = [8, 14, 10, 16, 12, 18, 9, 15];
    return spacings[index % spacings.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh'; // First image consistent with other pages
    const sizes = ['85vh', '60vh', '75vh', '65vh', '80vh'];
    return sizes[index % sizes.length];
  };
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-327" data-mp="3mfb1pt3kckga">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-328" data-mp="mzo27a452r35">
        <div className="flex space-x-6" data-id="element-329" data-mp="n1iddwplz4u1">
          <div className="text-base font-normal" data-id="element-330" data-mp="i1m8zwd01bdy">
            <Link to="/" className="transition-colors duration-200"
          // Apply random color directly in the JSX
          style={{
            color: getRandomColor()
          }} data-color-applied="true" data-id="element-331" data-mp="i2xd5xacwl5l">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-332" data-mp="10ydzoquvess1">
            <Link to="/info" className="transition-colors duration-200"
          // Apply random color directly in the JSX
          style={{
            color: getRandomColor()
          }} data-color-applied="true" data-id="element-333" data-mp="10xm2xcpjep06">
              Info
            </Link>
          </div>
        </div>
      </header>
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-334" data-mp="2qe7zfq0jd7ou">
        <div className="flex min-w-max" data-id="element-335" data-mp="2ciw2rd2tl75a">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-336" data-mp="2hgfg8arp1fw6">
            <div className="text-base max-w-[360px] pr-4" data-id="element-337" data-mp="22kg8j18hxhrk">
              <div data-id="element-338" data-mp="27gx065ewme9e">
                Motherhood Story (<em data-id="element-339" data-mp="27hyld2pmwh4u">The Fourth Magazine</em>, 2026)
              </div>
              <div className="mt-4" data-id="element-340" data-mp="sbo0atbtmqv">Coming soon...</div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-341" data-mp="5qljkmiyqpd0">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-342" data-mp="1l9t69j2jnhic" data-mpi={index}>
                <img src={image} alt={`Motherhood Story - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-343" data-mp="1v5e4d64hrxmt" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-344" data-mp="2dyi2b3oqswn8">
        <div className="mb-8" data-id="element-345" data-mp="oisa6ko6y415">
          <div className="text-base mb-4" data-id="element-346" data-mp="ok3huvkrbvxj">
            Motherhood Story (<em data-id="element-347" data-mp="jk79kk511ic6">The Fourth Magazine</em>, 2026)
          </div>
          <div data-id="element-348" data-mp="jls3c7jiox8z">Coming soon...</div>
        </div>
        <div className="w-full space-y-8" data-id="element-349" data-mp="l1melmpttm0j">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-350" data-mp="pzxo1wc7lui8" data-mpi={index}>
              <img src={image} alt={`Motherhood Story - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-351" data-mp="pymk9wirkmr4" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-352" data-mp="zw0z5rp1h3hb" />
      <style jsx data-id="element-353" data-mp="2b50an5qqsyp">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default MotherhoodStoryPage;